
namespace Matrix.Indexation {

    @Serenity.Decorators.registerEditor('Matrix.Indexation.IndexationProfileIndexRorGrid')
    export class IndexationProfileIndexRorGrid extends SiteEntityGrid<IndexRorRow, any> {
        protected getColumnsKey() { return IndexRorColumns.columnsKey; }
        protected getDialogType() { return IndexRorDialog; }
        protected getIdProperty() { return IndexRorRow.idProperty; }
        protected getInsertPermission() { return IndexRorRow.insertPermission; }
        protected getLocalTextPrefix() { return IndexRorRow.localTextPrefix; }
        protected getService() { return IndexRorService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }

        getInitialTitle() {
            return null;
        }

        private _indexationProfileCode: string;

        get indexationProfileCode(): string {
            return this._indexationProfileCode;
        }

        set indexationProfileCode(value: string) {
            if (this._indexationProfileCode != value) {
                this._indexationProfileCode = value;
                this.setEquality(IndexRorRow.Fields.IndexationProfileCode, value);
                this.refresh();
            }
        }

        protected getGridCanLoad() {
            return super.getGridCanLoad() && !!this._indexationProfileCode;
        }
    }
}